'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = require('./validators/index');

var validatorRegistry = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Uses the registered validators to determine whether the specified field value is valid given its field config.
 *
 * @param fieldValue {String} The value of the field.
 * @param validationConfig {Object} An object that specifies the validations to apply to the field value.
 *          See validationConstants.js.
 * @returns {Object|null} null if the field value is valid, otherwise an object describing the validation failure.
 */
exports.default = function (fieldValue, validationConfig) {
    var errorObject = null;

    for (var validatorName in validatorRegistry) {
        if (!validatorRegistry.hasOwnProperty(validatorName)) continue;

        var validator = validatorRegistry[validatorName];

        // Perform the validation
        errorObject = validator(fieldValue, validationConfig);

        // Short circuit on error to prevent unneeded validation tests
        if (errorObject) break;
    }

    return errorObject;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/fieldValidationService.js
// module id = 488
// module chunks = 0